
export const setCookie = (name, value, days) => {
  let expires = "";
  if (days) {
    let date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = `; expires=${date.toUTCString()}`;
  }
  document.cookie = `${name}=${value || ""}${expires}; path=/`;
};

export const getCookies = () =>
  decodeURIComponent(document.cookie)
    .split(';').map(cookie => {
      const parsedCookie = cookie.split('=');
      const cookieName = parsedCookie[0] || "";
      const cookieValue = parsedCookie[1] || "";

      return {
        name: cookieName.trim(),
        value: cookieValue.trim()
      };
    });

export const getCookie = (cookieName) => {
  const cookies = getCookies();
  const cookie = cookies.find(cookie => cookie.name === cookieName);
  return cookie ? cookie.value : null;
};
